import React from 'react';
import { ViewModelReturnType } from '../../types';
import View from './View';

const Main = (props: ViewModelReturnType) => {
    return <View {...props} />;
};

export default Main;
